import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
// Di-bundle sendiri lewat Vite, bukan dari CDN pihak ketiga — ikon tetap
// tampil walau CDN bermasalah, dan tidak ada permintaan ke domain luar.
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);